export class FamilyRequest {
  familyName: string;
  firstName: string;
  lastName: string;
  iban: string;
  bank: string;
  branch: string;
  controlDigit: string;
  internalBankAccountNumber: string;
  identification: string;
  isAmpa: boolean;
  address: string;
  city: string;
  province: string;
  email: string;
  zipCode: string;
  sendInvoiceByEmail: boolean;
  phone: string;
  mobilePhone: string;
  familyDocumentType: number;
  languageId: number;
  exerciseId: number;
  schoolId: number;
  profitCenterCode: string;
  schoolNumber: number;
}
